export enum ProjectedHeadcountFieldType {
  Employee = 1,
  Growth = 2
}